// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};



//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/~/core-js/modules/_species-constructor.js
// module id = ../../../../core-js/modules/_species-constructor.js
// module chunks = 0